export const NAME = 'ultimateUploader'
export { NAME as default }
